import React from 'react';
import { useIsMobile } from '../../hooks/useIsMobile';
import FeaturesDesktop from './features/FeaturesDesktop';
import FeaturesMobile from './features/FeaturesMobile';

// This is the section with the real desktop/mobile divergence: a 2x2 grid of
// rich cards on desktop vs. full-bleed sticky-stacked portrait cards on
// mobile, with genuinely different overlay content in a couple of cases
// (Feature 2's white card vs. glass chips, Feature 3's 3x3-vs-2x4 signal
// grid) — not just the same layout resized.
const Features = () => {
  const isMobile = useIsMobile();
  return isMobile ? <FeaturesMobile /> : <FeaturesDesktop />;
};

export default Features;
